import React from "react";
import { FaAngleDoubleDown } from "react-icons/fa";
import Fade from "react-reveal/Fade";

function Section({ titre, description, image, page, btnText, down }) {
  return (
    <div className={`wrapSection ${image}`}>
      <Fade bottom>
        <div className="textItem">
          <h1>{titre}</h1>
          <p>{description}</p>
        </div>
      </Fade>
      <div>
        <Fade bottom>
          <div className="btnContainer">
            {btnText && (
              <a href={page}>
                <button className="btnText">{btnText}</button>
              </a>
            )}
          </div>
        </Fade>
        {down && (
          <div className="downArrow">
            <FaAngleDoubleDown className="icon" />
          </div>
        )}
      </div>
    </div>
  );
}

export default Section;
